module.exports = "/images/plan-features-mark-icon.svg?b078cd284b57cb8991e7b8c8d4c6aee6";